import { accountBankList } from '@/views/payment/merchantManage/request';
import { logisticsSelectList } from '@/views/claim/customerRecordManage/utils';
const statistics = [{
  // controlName: '赔付金额',
  controlName: window.vm.$i18n.t('赔付金额'),
  mark: '',
  isHighlighted: false,
  editing: false,
  isSelected: false,
  isSelectedShow: false,
  widthSet: '50%',
  isRequired: false,
  minWordCount: 0,
  maxWordCount: 500,
  promptText: '',
  controlExplain: '',
  partsType: 'payment',
  isCheck: false,
  // 是否选中当前模块
  groupSelected: false,
  //是否选中控件组
  association: {
    //没有关联关系时是空对象
    relationType: '',
    //多个关联时拓展结构
    association: []
  }
}, {
  // controlName: '估损金额',
  controlName: window.vm.$i18n.t('估损金额'),
  mark: '',
  isHighlighted: false,
  editing: false,
  isSelected: false,
  isSelectedShow: false,
  widthSet: '50%',
  isRequired: false,
  minWordCount: 0,
  maxWordCount: 500,
  promptText: '',
  controlExplain: '',
  partsType: 'estimate',
  isCheck: false,
  // 是否选中当前模块
  groupSelected: false,
  //是否选中控件组
  association: {
    //没有关联关系时是空对象
    relationType: '',
    //多个关联时拓展结构
    association: []
  }
}];

// 多选--isMultiple : '',
// 必填--isRequired: ""
// 是否必填 isRequired 默认是否
// 宽度限制--widthSet  默认是50%
//属性校验----------------默认值是单上文本
// 单行文本 attributeVerification: 'text',
// controlType: '', // 用户选择的控件类型
// fields: [], // 对应控件类型的字段信息
// minLength: 0, // 最小字数范围值
// maxLength: 200, // 最大字数范围值
// decimalPlaces: 2, // 小数点位数
// minValue: 0, // 数值限制的最小值
// maxValue: 40000000 // 数值限制的最大值
//isSelected: false, 默认是关闭状态 关联、下拉、上移
// 编辑内容--editing: false,默认是关闭
// isSelectedShow--选中后的样式
// isHighlighted--悬浮的样式

// selectedFormats: [],---文件格式显示的内容
// { //单行文本 （控件名：赔付金额、估损金额时 控件名称不能修改）
//   "partsType": "singleLine",
//   "controlName": "控件名称",
//   "promptText": "提示文字",
//   "controlExplain": "控件说明",
//   "prefix": "前缀",
//   "suffix": "后缀",
//   "attributeVerification": "属性校验  SINGLE_LINE单行文本、NUMBER数字、PHONE手机号、IDCODE身份证、EMAIL邮箱",
//   "decimalPlaces": "小数点位",
//   "numberLimit": "字数限制  例子：1,10",
//   "widthSet": "宽度设置  10 20 30 40 50 60 70 80 90 100%",
//   "isRequired": "是否必填  true是  false否",
//   "mark": "标识",
//   "statistical": "amount", //与partsType：singleLine单行文本组成统计控件(amount:统计赔付金额、估损金额)
//   "is_show": "是否显示该控件 true是  false否",
//   "value": "应用端值",
// },

const control = [{
  isHighlighted: false,
  isSelectedShow: false,
  isSelected: false,
  editing: false,
  partsType: 'singleLine',
  // controlName: '单行文本',
  controlName: window.vm.$i18n.t('单行文本'),
  promptText: '',
  controlExplain: '',
  prefix: '',
  suffix: '',
  attributeVerification: 'SINGLE_LINE',
  decimalPlaces: 2,
  //小数点位数
  textMinLength: 0,
  textMaxLength: 200,
  numberMinValue: 0,
  // 数值限制的最小值
  numberMaxValue: 40000000,
  // 数值限制的最大值
  numberLimit: '0,200',
  //"字数限制  例子：1,10",
  widthSet: '50%',
  isRequired: false,
  // "是否必填  true是  false否",
  mark: '',
  isCheck: false,
  // 是否选中当前模块
  is_show: '',
  value: '',
  groupSelected: false,
  //是否选中控件组
  association: {
    //没有关联关系时是空对象
    relationType: '',
    //多个关联时拓展结构
    association: []
  }
}, {
  isHighlighted: false,
  editing: false,
  isSelected: false,
  isSelectedShow: false,
  widthSet: '50%',
  isRequired: false,
  numberLimit: '0,500',
  minWordCount: 0,
  maxWordCount: 500,
  promptText: '',
  controlExplain: '',
  id: 2,
  // controlName: '多行文本',
  controlName: window.vm.$i18n.t('多行文本'),
  icon: 'snippets',
  infoId: 1,
  partsType: 'multiline',
  isCheck: false,
  // 是否选中当前模块
  groupSelected: false,
  //是否选中控件组
  association: {
    //没有关联关系时是空对象
    relationType: '',
    //多个关联时拓展结构
    association: []
  },
  value: ''
}, {
  // 单选
  isHighlighted: false,
  //------------新增
  editing: false,
  //------------新增
  isSelected: false,
  //------------新增
  isSelectedShow: false,
  //------------新增

  partsType: 'singleChoice',
  // controlName: '单选', //"控件名称",
  controlName: window.vm.$i18n.t('单选'),
  controlExplain: '',
  //"控件说明",
  // DAoptions: [{ text: '', allowEmpty: false, emptyValue: '', showInput: false }], //表单中数据回显
  selectedOption: '',
  //定义空作为初始值单选内容--------------------新增
  controlValue: [{
    name: '',
    //选项值
    isWrite: false,
    //允许填写
    emptyValue: '',
    //输入框的值-------------新增
    showInput: false,
    //点击是否显示输入框------------新增
    association: {
      type: '',
      // "or或 and且",
      association: [] // 如果为空则代表没有关联关系
    }
  }],
  isCheck: false,
  // 是否选中当前模块
  sortWay: {
    type: 'TRANSVERSE',
    value: 2
  },
  //type:VERTICAL竖向排列、TRANSVERSE横向排列;value:TWO每行2列、THREE每行3列、FOUR每行4列、FIVE每行5列、SIX每行6列、SEVEN每行7列、EIGHT每行8列、NINE每行9列、TEN每行10列;
  isRequired: false,
  //"是否必填 true是  false否",
  macroStyle: 'ALL',
  //"宏样式 ALL展示全部选项 Selected仅展示选中选项",
  mark: '',
  // "标识",
  is_show: false,
  //  "是否显示该控件 true是  false否",
  value: '',
  is_tag: false,
  //"是否标签 true是  false否"
  groupSelected: false,
  //是否选中控件组
  association: {
    //没有关联关系时是空对象
    relationType: '',
    //多个关联时拓展结构
    association: [
      // {
      //   hideControl: '',
      //   where1: '', //多个关联时拓展结构
      //   type: 'one' //one任一 、all全部
      // }
    ]
  }
}, {
  // 多选
  isHighlighted: false,
  editing: false,
  isSelected: false,
  isSelectedShow: false,
  partsType: 'multipleChoice',
  // controlName: '多选', //"控件名称",
  controlName: window.vm.$i18n.t('多选'),
  controlExplain: '',
  //"控件说明",
  // DXoptions: [
  //   { text: '', allowEmpty: false, emptyValue: '' }
  // ],
  selectedOptionsDX: [],
  //定义空数组作为初始值多选内容---------------新增
  controlValue: [{
    name: '',
    //选项值
    isWrite: false,
    //允许填写
    emptyValue: '',
    //输入框的值-------------新增
    showInput: false //点击是否显示输入框------------新增
  }],
  isCheck: false,
  // 是否选中当前模块
  numberLimit: '',
  //"numberLimit": "选项数量  例子：1, 10",
  numberLimit1: 0,
  //选项数量最小------------------新增
  numberLimit2: 10,
  //最大-------------------------新增
  sortWay: {
    type: 'VERTICAL',
    value: 2
  },
  //sortWay:VERTICAL竖向排列、TRANSVERSE横向排列",
  isRequired: false,
  //"是否必填  true是  false否",
  mark: '',
  // "标识",
  macroStyle: 'ALL',
  //"宏样式 ALL展示全部选项 Selected仅展示选中选项",
  is_show: false,
  //  "是否显示该控件 true是  false否",
  value: '',
  is_tag: false,
  //"是否标签 true是  false否"
  groupSelected: false,
  //是否选中控件组
  association: {
    //没有关联关系时是空对象
    relationType: '',
    //多个关联时拓展结构
    association: [
      // {
      //   hideControl: '',
      //   where1: '', //多个关联时拓展结构
      //   type: 'one' //one任一 、all全部
      // }
    ]
  }
}, {
  isHighlighted: false,
  editing: false,
  isSelected: false,
  isSelectedShow: false,
  partsType: 'dropDown',
  // controlName: '下拉选择', //"控件名称",
  controlName: window.vm.$i18n.t('下拉选择'),
  promptText: '',
  //"提示文字",
  controlExplain: '',
  //"控件说明",
  selectedValues: [],
  //获取下拉选中的值----------------新增
  Customvalues: [],
  //需要一个值存储自定义的值
  type: {
    type: '',
    //选择的类型国家、省市、
    // controlMark: '控件标识（根据控件标识查询自定义数据）',
    controlMark: window.vm.$i18n.t('控件标识（根据控件标识查询自定义数据）'),
    association: [
      // {
      //   cascadeId: "自定义ID（关联一级中的某一个值的ID）",
      //   type: "or或 and且",
      //   association: [
      //     {
      //       hideControl: "mark,mark",
      //       where1: "所关联控件1"
      //     }
      //   ]
      // }
    ] //通过最外层判断
  },
  //控件类型type： country国家 provinceArea省市区（三级） province省市（二级） area地区代码 p
  isCheck: false,
  // 是否选中当前模块
  widthSet: '50%',
  //"宽度设置  10 20 30 40 50 60 70 80 90 100%",
  isMultipleChoice: false,
  //"是否多选  true是  false否",
  isRequired: false,
  //"是否必填  true是  false否",
  mark: '',
  // "标识",
  is_show: false,
  //  "是否显示该控件 true是  false否",
  value: '',
  is_tag: false,
  //"是否标签 true是  false否"
  groupSelected: false,
  //是否选中控件组
  association: {
    //没有关联关系时是空对象
    relationType: '',
    //多个关联时拓展结构
    association: [
      // {
      //   hideControl: '',
      //   where1: '', //多个关联时拓展结构
      //   type: 'one' //one任一 、all全部
      // }
    ]
  }
}, {
  partsType: 'date',
  dateType: 'YYYY-MM-DD',
  dateStart: {
    type: 'UNLIMITED',
    value: '',
    unit: 'DAY',
    //选择类型-日 月 年
    dateInput: '' //输入的数值
  },
  dateEnd: {
    type: 'UNLIMITED',
    value: '',
    unit: 'DAY',
    //选择类型-日 月 年
    dateInput: ''
  },
  // controlName: '选择日期', //"控件名称",
  controlName: window.vm.$i18n.t('选择日期'),
  promptText: '',
  // "提示文字",
  controlExplain: '',
  // "控件说明",
  numberLimit: '',
  //"字数限制  例子：1,10",
  widthSet: '50%',
  isRequired: false,
  // "是否必填  true是  false否",
  mark: '',
  is_show: false,
  //  "是否显示该控件 true是  false否",
  value: '',
  isHighlighted: false,
  editing: false,
  isSelected: false,
  isSelectedShow: false,
  isCheck: false,
  // 是否选中当前模块
  groupSelected: false,
  //是否选中控件组
  association: {
    //没有关联关系时是空对象
    relationType: '',
    //多个关联时拓展结构
    association: []
  }
}, {
  // 附件
  fileListData: [],
  //// 已上传文件列表  不然会导致共享数据所有的附件共享一份数据
  partsType: 'enclosure',
  // controlName: '附件', //"控件名称",window.vm.$i18n.t('复制成功')
  controlName: window.vm.$i18n.t('附件'),
  promptText: '',
  //"提示文字",
  controlExplain: '',
  //"控件说明",
  fileFormat: [],
  //"文件格式：Word Xlsx xls JPG mov jpeg mp4 PDF BMP docx doc rm rmvb avi jpg pdf png",
  fileSize: {
    size: 1,
    type: 'MB'
  },
  //"文件大小:{"size":10,"type":MB/KB}" ,//type:MB KB",
  fileNumber: {
    is_many: false,
    value: 2
  },
  //"上传多张:{"is_many":true,"value":10}", //is_many:true是  false否",
  templateUrl: [],
  //"url,url 英文逗号分隔",
  isRequired: true,
  // "是否必填  true是  false否",
  mark: '',
  // "标识",
  is_show: true,
  //"是否显示该控件 true是  false否",
  value: '',
  widthSet: '50%',
  isHighlighted: false,
  editing: false,
  isSelected: false,
  isSelectedShow: false,
  isCheck: false,
  // 是否选中当前模块
  groupSelected: false,
  //是否选中控件组
  association: {
    //没有关联关系时是空对象
    relationType: '',
    //多个关联时拓展结构
    association: []
  }
}, {
  // 段落控件
  isHighlighted: false,
  isSelectedShow: false,
  isSelected: false,
  editing: false,
  partsType: 'paragraph',
  controlName: '',
  //"控件名称",
  content: '',
  //字体/字号/加粗/斜体/下划线/字体颜色/字体背景颜色/对齐方式/图片/超链接
  widthSet: '100%',
  mark: '',
  isCheck: false,
  // 是否选中当前模块
  is_show: '',
  value: '',
  groupSelected: false,
  //是否选中控件组
  association: {
    //没有关联关系时是空对象
    relationType: '',
    //多个关联时拓展结构
    association: []
  }
}, {
  //签名
  isHighlighted: false,
  isSelectedShow: false,
  isSelected: false,
  editing: false,
  //是否显示内容
  partsType: 'sign',
  controlName: '',
  //"控件名称",
  url: '',
  mark: '',
  is_show: false,
  //"是否显示该控件 true是  false否,
  value: '',
  is_tag: 'false',
  isCheck: false,
  // 是否选中当前模块
  groupSelected: false,
  //是否选中控件组
  association: {
    //没有关联关系时是空对象
    relationType: '',
    //多个关联时拓展结构
    association: []
  }
}, {
  isHighlighted: false,
  isSelectedShow: false,
  isSelected: false,
  editing: false,
  partsType: 'table',
  mark: '',
  tableData: [{
    column1: '',
    column2: ''
  }],
  containerTemplateId: -1,
  containerTemplateInfo: '',
  isCheck: false,
  // 是否选中当前模块
  is_show: '',
  value: '',
  groupSelected: false,
  //是否选中控件组
  association: {
    //没有关联关系时是空对象
    relationType: '',
    //多个关联时拓展结构
    association: []
  }
}];
const advanceControl = [
// 控件组
{
  isHighlighted: false,
  editing: false,
  isSelected: false,
  isSelectedShow: false,
  // controlName: '控件组',
  controlName: window.vm.$i18n.t('控件组'),
  icon: 'snippets',
  infoId: 1,
  controlType: 'controlGroup',
  mark: '',
  controlExplain: '',
  widthSet: '50%',
  // blankTxt: '选中右侧控件组后点击左侧控件添加',
  blankTxt: window.vm.$i18n.t('选中右侧控件组后点击左侧控件添加'),
  isCheck: false,
  // 是否选中当前模块
  is_show: '',
  value: '',
  groupSelected: false,
  //是否选中控件组--用来判断有多个控件组时，切换控件组时清除之前选中的控件组和它里面的控件的选中状态
  control: [],
  association: {
    //没有关联关系时是空对象
    relationType: '',
    //多个关联时拓展结构
    association: []
  }
}];
const controlGroup = [{
  id: 1,
  name: '收件信息',
  icon: '',
  type: 'controlGroup',
  category: 'receiving'
}, {
  id: 2,
  name: '寄件信息',
  icon: 'right',
  type: 'controlGroup',
  category: 'mail'
}, {
  id: 3,
  name: '收款信息',
  icon: '',
  type: 'controlGroup',
  category: 'collection'
}, {
  id: 4,
  name: '打款信息',
  icon: '',
  type: 'controlGroup',
  category: 'payment',
  infoId: 7
}, {
  id: 5,
  name: '配件明细',
  icon: 'right',
  type: 'table',
  infoId: 6,
  category: 'accessories'
}];
const fileFormat = {
  picture: ['jpg', 'pdf', 'jpeg', 'png'],
  enclosure: ['xlsx', 'xls', 'docx', 'doc', 'rm', 'mp4', 'rmvb', 'avi']
};
const controlGroupInfo = {
  receiving: {
    controlTitle: '收件信息',
    controlType: 'controlGroup',
    control: [{
      partsType: 'singleLine',
      formName: '收件信息',
      controlName: '收件人',
      promptText: '请输入收件人姓名',
      other: 1
    }, {
      partsType: 'singleLine',
      formName: '收件信息',
      controlName: '联系方式',
      promptText: '请输入联系方式',
      other: 1
    }, {
      partsType: 'singleLine',
      formName: '收件信息',
      controlName: '具体地址',
      promptText: '请输入具体地址',
      other: 1
    }, {
      partsType: 'singleLine',
      formName: '收件信息',
      controlName: '备注'
    }]
  },
  mail: {
    controlTitle: '寄件信息',
    controlType: 'controlGroup',
    control: [{
      partsType: 'dropDown',
      formName: '寄件信息',
      controlName: '物流公司',
      promptText: '请选择物流公司',
      other: 1,
      option: logisticsSelectList.join(';'),
      optionList: logisticsSelectList
    }, {
      partsType: 'singleLine',
      formName: '寄件信息',
      controlName: '运单号',
      promptText: '请输入运单号',
      other: 1
    }, {
      partsType: 'singleLine',
      formName: '寄件信息',
      controlName: '备注'
    }]
  },
  collection: {
    controlTitle: '收款信息',
    controlType: 'controlGroup',
    control: [{
      partsType: 'dropDown',
      formName: '收款信息',
      controlName: '开户银行',
      promptText: '请选择开户银行',
      other: 1,
      option: accountBankList.join(';'),
      optionList: accountBankList
    }, {
      partsType: 'singleLine',
      formName: '收款信息',
      controlName: '开户行名称',
      promptText: '请输入开户行名称'
    }, {
      partsType: 'singleLine',
      formName: '收款信息',
      controlName: '银行账号',
      promptText: '请输入银行账号',
      other: 1
    }, {
      partsType: 'singleLine',
      formName: '收款信息',
      controlName: '备注'
    }]
  },
  payment: {
    controlTitle: '付款信息',
    controlType: 'controlGroup',
    control: [{
      partsType: 'date',
      formName: '付款信息',
      controlName: '付款时间',
      other: 1,
      dateType: 1
    }, {
      partsType: 'singleLine',
      formName: '付款信息',
      controlName: '付款金额',
      promptText: '请输入付款金额',
      other: 1
    }, {
      partsType: 'singleLine',
      formName: '付款信息',
      controlName: '备注'
    }, {
      partsType: 'picture',
      formName: '付款信息',
      controlName: '付款凭证',
      fileFormat: fileFormat.picture,
      template: []
    }]
  },
  accessories: {
    controlTitle: '配件明细',
    controlType: 'table',
    operation: '',
    control: [{
      slots: {
        title: '序号'
      },
      dataIndex: 'index',
      key: '1',
      align: 'center',
      scopedSlots: {
        customRender: 'index'
      },
      width: 80
    }, {
      slots: {
        title: '零配件编码'
      },
      dataIndex: 'code',
      key: '2',
      align: 'center'
    }, {
      slots: {
        title: '配件名称'
      },
      dataIndex: 'name',
      key: '3',
      align: 'center'
    }, {
      slots: {
        title: '配件照片'
      },
      dataIndex: 'photo',
      key: '4',
      align: 'center',
      scopedSlots: {
        customRender: 'photo'
      }
    }, {
      slots: {
        title: '门店意见'
      },
      dataIndex: 'opinion',
      key: '5',
      align: 'center'
    }, {
      slots: {
        title: '价格（元）'
      },
      dataIndex: 'price',
      key: '10',
      align: 'center'
    }, {
      slots: {
        title: '备注'
      },
      dataIndex: 'remarks',
      key: '6',
      align: 'center'
    }]
  }
};
export { statistics, control, controlGroup, fileFormat, controlGroupInfo, advanceControl };